import { UiComponent } from 'components';
import useModal from 'hooks/useModal';
import { ContentsFileServiceQuery } from 'queries';
import React, { useRef } from 'react';
import { TbUpload } from 'react-icons/tb';
import { useParams } from 'react-router-dom';

interface Props {
  handleSelect: (url: string) => void;
}

function ImageSelector({ handleSelect }: Props) {
  const { handleClose } = useModal();
  const { id } = useParams();
  const fileInputRef = useRef<HTMLInputElement>(null);

  const { data } = ContentsFileServiceQuery.useGet(id || '');
  const { handleUpload } = ContentsFileServiceQuery.useUpload();

  const handleFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        if (!id) return;
        handleUpload(id, file);
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div
      css={(theme) => ({
        width: 520,
        maxWidth: '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        '> ul': {
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(112px, 1fr))',
          gap: 8,
        },
        '> ul > li > button': {
          width: '100%',
          aspectRatio: '1',
          padding: 0,
          border: 'none',
          borderRadius: theme.radius.md,
          background: theme.color.grey50,
          overflow: 'hidden',
          cursor: 'pointer',
          ':hover': { boxShadow: `inset 0 0 0 2px ${theme.color.primary}` },
          img: { width: '100%', height: '100%', objectFit: 'cover' },
        },
        '> p': {
          padding: '32px 0',
          textAlign: 'center',
          fontSize: 14,
          color: theme.color.textMuted,
        },
      })}
    >
      <input
        type="file"
        name="thumbnail"
        onChange={handleFile}
        ref={fileInputRef}
        style={{ display: 'none' }}
      />
      <UiComponent.Button
        color="primary"
        variant="contained"
        css={{ alignSelf: 'flex-start' }}
        onClick={() => fileInputRef.current?.click()}
      >
        <TbUpload size={16} />
        이미지 업로드
      </UiComponent.Button>
      {data?.length ? (
        <ul>
          {data.map((i: { id: string; url: string }) => (
            <li key={i.id}>
              <button
                type="button"
                onClick={() => {
                  handleSelect(i.url);
                  handleClose();
                }}
              >
                <img src={i.url} alt="" />
              </button>
            </li>
          ))}
        </ul>
      ) : (
        <p>업로드한 이미지가 없어요</p>
      )}
    </div>
  );
}

export default ImageSelector;
